var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "all-detail-task" },
    _vm._l(_vm.taskDatas, function(item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: " progress-box-height",
          class: [
            _vm.taskDatas.length > 8 ? "progress-box-overflow" : "progress-box",
            item.open && item.itemProgressInfo ? "progress-failed-more" : "",
            item.open && !item.itemProgressInfo ? "progress-failed-less" : ""
          ],
          on: {
            mouseenter: function($event) {
              _vm.hoverCurrent = index
            },
            mouseleave: function($event) {
              _vm.hoverCurrent = -1
            },
            click: function($event) {
              return _vm.collapse(index, item)
            }
          }
        },
        [
          _c("div", { staticClass: "detailed-progress-box" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "task-info" },
            [
              _c("div", { staticClass: "task-info-name" }, [
                item.status == 3
                  ? _c("div", { staticClass: "task-status-name status-grey" }, [
                      _vm._v(_vm._s(_vm.$t("language.common.canceled")) + ":")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.getTaskStr(item) == "success8"
                  ? _c("div", { staticClass: "task-status-name status-blue" }, [
                      _vm._v(
                        _vm._s(_vm.$t("language.common.partialSuccess")) + ":"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.getTaskStr(item) == "error"
                  ? _c("div", { staticClass: "task-status-name status-grey" }, [
                      _vm._v(_vm._s(_vm.$t("language.common.failure")) + ":")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "detailed-sources-name",
                    attrs: { title: item.sourceFilename }
                  },
                  [_vm._v(" " + _vm._s(item.sourceFilename))]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "task-info-percent" }),
              _vm._v(" "),
              _vm.hoverCurrent == index
                ? _c("div", { staticClass: "task-info-speed" }, [
                    _c("div", {
                      staticClass: "icon-util taskinfo-collapse-position",
                      class: item.open ? "collapse-up" : "collapse-down"
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("unfinishedDetail", {
                attrs: { open: item.open, index: index, itemDetail: item }
              })
            ],
            1
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-123d1a2b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-123d1a2b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_detailed_progress/tab_unfinished_tasks.vue
// module id = null
// module chunks = 